"use strict";

var _require = require('content-type'),
  format = _require.format;
var _require2 = require('./errors'),
  InvalidContentTypeError = _require2.InvalidContentTypeError;
module.exports = function () {
  return {
    validate: function validate(contentType) {
      if (contentType) {
        try {
          format({
            type: contentType
          });
        } catch (err) {
          throw new InvalidContentTypeError(contentType);
        }
      }
    }
  };
};
//# sourceMappingURL=contentTypeValidator.js.map